<ng-container *ngIf="!choosingLanguage">
 
  <span routerLink="/">
    <h4 i18n="@@Search">Search</h4>
    <span i18n="@@FoliarTankmix">Tankmix for foliar application</span>
  </span>
  <span routerLink="/search-seed-treatment">
    <h4 i18n="@@Search">Search</h4>
    <span i18n="@@Search Seeds">Seed Coatings Tankmix</span>
  </span>
  <span routerLink="/request">
    <h4 i18n="@@Request">Request</h4>
    <span i18n="@@FoliarTankmix">New Foliar Tankmix</span>
  </span>
  <span routerLink="/request-seed-treatment" >
    <h4 i18n="@@Request">Request</h4>
    <span i18n="@@Seed Request"> New Seed Coatings Tankmix</span>
   </span>
  <span (click)="startChangeLanguage()" i18n="@@ChangeLanguage">
  Change Language</span>
  <span i18n="@@RefreshUi" (click)="forceRefresh()">Refresh</span>
  
  <span routerLink="/terms" i18n="@@Legal">Legal</span>
  <span routerLink="/contact" i18n="@@Contacts">Contacts</span>
  <span routerLink="/advice/On Mixing" i18n="@@Mixing">On mixing</span>
</ng-container>
<ng-container *ngIf="choosingLanguage">

  <span *ngFor="let language of languages; let i = index" (click)="changeLanguage(i)">
    {{ language.name }}
  </span>

</ng-container>